<script lang="ts" setup>
import MainNavAccountMenu from '@/components/landingPage/nav/MainNavAccountMenu.vue'
import type { JwtContent } from '@/types'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps<{
  modelValue: string | null
  cartItems: number
  jwt: JwtContent
  loggedIn: boolean
}>()

const emits = defineEmits<{
  (e: 'update:modelValue', v: string | null): void
  (e: 'logout', logout: boolean): void
}>()

const model = computed({
  get: () => props.modelValue,
  set: (v: string | null) => emits('update:modelValue', v)
})

const handleLogout = (logout: boolean) => {
  emits('logout', logout)
}
</script>

<template>
  <!-- under 700px -->
  <v-bottom-navigation
    v-model="model"
    :aria-label="t('a11y.bottomNavigation')"
    bg-color="primary"
    grow
    role="navigation"
  >
    <v-btn :to="{ name: 'landingPage' }" exact replace value="home">
      <v-icon icon="mdi-home" />
      <span>Home</span>
    </v-btn>

    <template v-if="!loggedIn">
      <v-btn :to="{ name: 'products' }" replace value="products">
        <v-icon icon="mdi-view-grid" />
        <span>{{ t('breadcrumbs.product') }}</span>
      </v-btn>
    </template>
    <template v-else>
      <v-btn :to="{ name: 'dashboardOverview' }" replace value="dashboard">
        <v-icon icon="mdi-view-dashboard" />
        <span>Dashboard</span>
      </v-btn>
    </template>

    <v-btn :to="{ name: loggedIn ? 'dashboardCart' : 'cart' }" replace value="cart">
      <v-icon icon="mdi-cart" />
      <span>Cart</span>
      <v-badge
        v-if="cartItems > 0"
        :content="cartItems"
        color="grey-darken-4"
        class="cart-badge"
      >
      </v-badge>
    </v-btn>

    <template v-if="!loggedIn">
      <v-btn :to="{ name: 'login' }" replace value="login">
        <v-icon icon="mdi-account" />
        <span>Login</span>
      </v-btn>
    </template>
    <template v-else>
      <main-nav-account-menu :jwt="props.jwt" @logout="handleLogout" />
    </template>
  </v-bottom-navigation>
</template>

<style scoped>
.cart-badge {
  position: absolute;
  transform: translateY(-10px) translateX(20px);
}
</style>
